"use strict";
/**
 * fichier de configuration de l'application pour la javascript
 * @author: Thiney Jean-Baptiste <jb@innov-appli.com>
 * @type {{}}
 */

/* Breakpoint System:
    * ------------------
* xs (Extra Small):  >= 320px  - Mobile devices (small phones)
* sm (Small):        >= 576px  - Mobile devices (standard phones)
* md (Medium):       >= 768px  - Tablets
* lg (Large):        >= 1100px - Desktop screens
* xl (Extra Large):  >= 1400px - Large desktop screens

 */
let configuration = {
    xs: 320,
    sm: 576,
    md: 768,
    lg: 1100,
    xl: 1400,
    gapScrollHeader: 100,
}

export default configuration;